import { Button, Flex } from "@chakra-ui/react";
import { CustomModal } from "components/custom-modal";
import { InputField } from "components/input-field";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { useEffect, useState } from "react";

export type ModalCorrigirUserBancoParams = {
  username?: string;
  password?: string;
};

const eventName = "openModalCorrigirUserBanco";

export const openModalCorrigirUserBanco =
  createModalTrigger<ModalCorrigirUserBancoParams>(eventName);

export function ModalCorrigirUserBanco() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { isOpen, onClose, params } =
    useModalControls<ModalCorrigirUserBancoParams>(eventName, {
      onOpen(params) {
        setUsername(params?.username || "");
        setPassword(params?.password || "");
      },
      onClose() {
        setUsername("");
        setPassword("");
      }
    });

  const handleSalvar = async () => {
    try {
    } catch (e) {
    } finally {
    }
  };

  const isSalvarDisabled = !username.trim() || !password.trim();

  const modalFooter = (
    <>
      <Button onClick={handleSalvar} isDisabled={isSalvarDisabled}>
        Salvar
      </Button>
      <Button variant="outline" onClick={onClose}>
        Cancelar
      </Button>
    </>
  );

  return (
    <CustomModal
      modalTitle="Corrigir usuário e senha"
      isOpen={isOpen}
      onClose={onClose}
      modalFooter={modalFooter}
    >
      <Flex direction="column" gap="12px" py="8px">
        <InputField
          title="Usuário"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <InputField
          title="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          inputProps={{ type: "password" }}
        />
      </Flex>
    </CustomModal>
  );
}
